/// <reference path="../../../typings/tsd.d.ts" /> 
enum LogicalOperator {
    And = 0,
    Or = 1
}